import get from 'lodash/get';
import {
  getItemOrDefaultToValue,
  getPersonName,
  // getElaspedTime,
} from '../../details';
import { getDistressResponseStatus } from '../../helper/distress';
import { getDisplayRoles } from '../../helper/roles';
import { displayTime } from '../../time';
// import { DISTRESS_RESPONSE_STATUS } from '../../../utils/constants/distressStatus';
import { PAGE_URLS } from 'utils/constants';

export const transformRawDistresses = ({ list, timeZone }) => {
  return list.map(distress => {
    return {
      id: get(distress, 'id'),
      pageName: PAGE_URLS.EMERGENCIES.link,
      ref: get(distress, 'ref'),
      distressee_role: getDisplayRoles(distress.distressee.general),
      distressee_name: getPersonName(distress.distressee.general),
      distressee_phone:
        distress.distressee.general.phoneNumber !== null
          ? `${getItemOrDefaultToValue(
              distress.distressee.general.phoneNumber,
              'prefix',
            )} ${getItemOrDefaultToValue(
              distress.distressee.general.phoneNumber,
              'number',
              '-',
            )}`
          : '-',
      distressee_location:
        distress.distressee !== null &&
        distress.distressee.operational.location !== null
          ? getItemOrDefaultToValue(
              distress.distressee.operational.location,
              'point',
            )
          : undefined,
      responder_name:
        distress.responder !== null
          ? getPersonName(distress.responder.general)
          : '-',
      responder_id:
        distress.responder !== null
          ? getItemOrDefaultToValue(distress.responder.general, 'id')
          : '-',
      responder_phone:
        distress.responder !== null
          ? `${getItemOrDefaultToValue(
              distress.responder.general.phoneNumber,
              'prefix',
            )} ${getItemOrDefaultToValue(
              distress.responder.general.phoneNumber,
              'number',
              '-',
            )}`
          : '-',
      responder_location:
        distress.responder !== null &&
        distress.responder.operational.location !== null
          ? getItemOrDefaultToValue(
              distress.responder.operational.location,
              'point',
            )
          : undefined,
      created_at: displayTime({
        timestamp: getItemOrDefaultToValue(distress, 'currentStatusTimestamp'),
        timeZone,
      }),
      timestamp: getItemOrDefaultToValue(distress, 'currentStatusTimestamp'),
      /**
       * TODO: Decide if we want to hide a column or refresh the elapse time
       */
      // elapsed_time: getElaspedTime(
      //   {
      //     currentStatus: distress.currentStatus,
      //     startTime: distress.statusAudit.find(
      //       key => key.status === DISTRESS_RESPONSE_STATUS.NEW.id,
      //     ).timestamp,
      //     currentStatusTimestamp: distress.currentStatusTimestamp,
      //   },
      //   current,
      // ),
      status: getDistressResponseStatus(distress),
    };
  });
};
